export default __webpack_public_path__ + "static/media/Group 2016(2).454503a4.svg";